import { createSelector } from '@reduxjs/toolkit';
import { appSlice } from '@containers/App/slice';
const selectAppState = createSelector((state) => state, (state) => state[appSlice.name]);
export const selectAppData = createSelector(selectAppState, (state) => state.data);
export const selectAppStepDetails = createSelector(selectAppData, (data) => data.step);
export const selectIsLoadingStepDetails = createSelector(selectAppState, (state) => state.request.isLoadingStepDetails);
export const selectRegistrationFormId = createSelector(selectAppStepDetails, (stepDetails) => stepDetails?.step_forms?.find((f) => f.form?.type === 'REGISTRATION')?.form?.id ?? null);
